export const PrimaryColor = '#293c77';
export const SecondaryColor = '#9a4040';
export const WhiteColor = '#ffffff';
export const BlackColor = '#333333';
export const OtherColor = '#3c4d36';
